import { QueryClient } from '@tanstack/react-query';
import { GlobalPermission } from '@wavingroup/aqora-v2-api/wavin/aqora/v2/user_pb';
import { LoaderFunctionArgs } from 'react-router';
import { requireUserGlobalPermission } from '~/shared/auth/auth-utils';

export const systemCreatePageLoader =
  (queryClient: QueryClient) =>
  async ({ request }: LoaderFunctionArgs) => {
    await requireUserGlobalPermission(
      queryClient,
      request,
      GlobalPermission.CREATE_SYSTEM,
    );

    return null;
  };
